import { alpha, Box, useMediaQuery } from "@mui/material";
import AdminLogoutDialog from "components/AdminLogoutDialog/AdminLogoutDialog";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getFromStore, StoreType } from "services/localStorage";
import theme from "themes/Theme";
import Sidebar, { drawerWidth } from "./_aside";
import Header from "./_header";

const AdminLayout = () => {
  const [open, setOpen] = useState<boolean>(false);
  const user: any = getFromStore(StoreType.AUTH);
  const [logoutModal, setLogoutModal] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role && user?.role?.toLowerCase() === "user") {
      navigate("/dashboard", { replace: true });
    }
  }, [user]);

  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };

  const showLogoutModal = () => {
    setLogoutModal(true);
  };

  const handleLogout = () => {
    dispatch({ type: "RESET_ALL_STATE" });
    localStorage.clear();
    setLogoutModal(false);
    navigate("/admin/login", { replace: true });
  };

  return (
    <Box sx={styles.container}>
      {pathname !== "/admin/login" && (
        <Sidebar
          open={open}
          toggleDrawer={toggleDrawer}
          isMobile={isMobile}
          logoutModal={showLogoutModal}
        />
      )}

      <Box sx={styles.layoutContainer}>
        {pathname !== "/admin/login" && (
          <Box
            sx={{
              width:
                pathname === "/admin/login"
                  ? "100%"
                  : isMobile
                  ? "100%"
                  : `calc(100% - ${drawerWidth})`,
              marginLeft: isMobile ? 0 : drawerWidth,
              borderBottom: `1px solid ${alpha(
                theme.palette.primary.main,
                0.3
              )}`,
              backgroundColor: "#FFFFFF",
              position: "fixed",
              top: 0,
              zIndex: 1000,
            }}
          >
            <Header toggleDrawer={toggleDrawer} isMobile={isMobile} />
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            pl: pathname === "/admin/login" ? 0 : isMobile ? 2 : "26%",
            pr: pathname === "/admin/login" ? 0 : isMobile ? 2 : "20px",
            paddingTop: pathname === "/admin/login" ? 0 : "100px",
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            minHeight: "100vh",
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {logoutModal && (
        <AdminLogoutDialog
          open={logoutModal}
          handleLogout={handleLogout}
          handleClose={() => setLogoutModal(false)}
        />
      )}
    </Box>
  );
};
export default AdminLayout;
const styles = {
  container: { display: "flex", flexDirection: "row" },
  layoutContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
};
